


import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getFirestore, collection, getDocs, addDoc, doc, updateDoc } from "firebase/firestore";
import { getStorage } from "firebase/storage";



const firebaseConfig = {
  apiKey: "AIzaSyA4zxi-MYNZoPQ1-xeVGm05Wv59qIOuECU",
  authDomain: "ekanayake-optical.firebaseapp.com",
  projectId: "ekanayake-optical",
  storageBucket: "ekanayake-optical.firebasestorage.app",
  messagingSenderId: "184949180163",
  appId: "1:184949180163:web:bc4a1e5055c3b9a9b48b36"
};


const app = initializeApp(firebaseConfig);

const db = getFirestore(app);  // Firestore initialization
const storage = getStorage(app);  // Firebase Storage initialization

export const auth = getAuth(app);
export { db, storage, getDocs, collection, addDoc, doc, updateDoc  };  // Correct export